import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PdfClosingReportViewComponent } from './pdf-closing-report-view.component';

const routes: Routes = [
  {
    path: '',
    component: PdfClosingReportViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PdfClosingReportViewRoutingModule { }
